import type { UserRef, WorkflowItem } from "@nmt/shared";
import { useQuery } from "@tanstack/react-query";
import { get } from "./api";

/** Active workflows (job types) with their stages. */
export function useWorkflows() {
  return useQuery({ queryKey: ["workflows"], queryFn: () => get<WorkflowItem[]>("/api/workflows"), staleTime: 5 * 60_000 });
}

/** Everyone who has a user, for sales rep pickers and names. */
export function useUsers() {
  return useQuery({ queryKey: ["users-directory"], queryFn: () => get<UserRef[]>("/api/users/directory"), staleTime: 5 * 60_000 });
}
